(ns app.front.ui.action-buttons
  (:require [app.front.ui.blip :as ui-blip]
            [core.front.carbon :as cc]
            [core.util.util :as util]))


(defn action-buttons
  "Group of styled action buttons"
  [{:keys [size buttons align loading?]}]
  (into [:div.flex.flex-row.flex-wrap.items-baseline
         {:class [(if (-> align keyword (= :left)) "justify-start" "justify-end")
                  (if (-> size keyword (= :small)) "gap-2" "gap-4")]}
         (when loading? (cc/loading-spinner {:with-overlay false :small true}))]
        (->> buttons
             (remove nil?)
             (map-indexed (fn [index {:keys [on-click disabled? text blip-text icon href id kind]}]
                            (let [button-opts (merge {:kind     (or kind
                                                                    (-> [:primary :tertiary]
                                                                        (get (- (count buttons) (inc index)))
                                                                        (or :ghost)))
                                                      :size     (or size :default)
                                                      :disabled (or loading? (boolean disabled?))}
                                                     (when icon
                                                       {:icon             icon
                                                        :icon-description text})
                                                     (when on-click {:on-click on-click})
                                                     (when href {:href href})
                                                     (when id {:id id}))]
                              (if blip-text
                                [ui-blip/blip
                                 (fn [show-blip]
                                   (cc/button (merge button-opts
                                                     {:on-click (fn []
                                                                  (on-click)
                                                                  (show-blip blip-text))})
                                              text))]
                                (cc/button
                                  button-opts
                                  text))))))))


(defn save-cancel-buttons
  "Cancel + save button. `disabled?` overrides key-specific disable-toggles."
  [{:keys [tr on-cancel on-save save-disabled? cancel-disabled? disabled? loading? save-tr cancel-tr size]}]
  (let [buttons [{:on-click  on-cancel
                  :disabled? (boolean (or cancel-disabled? disabled?))
                  :text      (tr [(or cancel-tr :cancel)])}
                 {:on-click  on-save
                  :disabled? (boolean (or save-disabled? disabled?))
                  :text      (tr [(or save-tr :save)])}]]
    [action-buttons (util/mmap size buttons loading?)]))
